import { useEffect } from "react";
import { useLocation } from "react-router-dom";

/**
 * ScrollToTop component
 * Automatically scrolls to the top of the page on route changes.
 * Works with nested routes in React Router v6+.
 */

interface iScrollToTopProps {
    element?: HTMLElement | null;
}

export default function ScrollToTop({ element }: iScrollToTopProps) {
  const { pathname, search, hash } = useLocation();

  useEffect(() => {
    // If there's a hash (#section), scroll to that element
    if (hash) {
      const element = document.querySelector(hash);
      if (element) {
        element.scrollIntoView({ behavior: "smooth" });
        return;
      }
    }

    // Otherwise, scroll to top
    if (element) {
        element.scrollTo({ top: 0, left: 0, behavior: "instant" });
    } else {
        window.scrollTo({ top: 0, left: 0, behavior: "instant" });
    }
  }, [pathname, search, hash]);

  return null; // This component doesn't render anything
}